/**
 * Shared EmptyState component — centered icon + title + optional subtitle + optional action.
 *
 * Usage:
 *   <EmptyState title="No tasks yet." />
 *   <EmptyState icon="📋" title="No tasks match your filters" subtitle="Try clearing your filters." action={<button>Clear</button>} />
 */
const DefaultIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "var(--text-3)", opacity: 0.6 }}>
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 0 0-4 0v2"/>
    <line x1="12" y1="12" x2="12" y2="16"/>
    <line x1="10" y1="14" x2="14" y2="14"/>
  </svg>
);

export default function EmptyState({ icon, title, subtitle, action }) {
  return (
    <div style={{ padding: "40px 24px", textAlign: "center" }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
        {icon ? <span style={{ fontSize: 28 }}>{icon}</span> : <DefaultIcon />}
      </div>
      <div style={{
        fontWeight: 600, fontSize: 14,
        color: "var(--text-2)",
        marginBottom: subtitle || action ? 6 : 0,
      }}>
        {title}
      </div>
      {subtitle && (
        <div style={{
          fontSize: 13, color: "var(--text-3)",
          marginBottom: action ? 14 : 0,
        }}>
          {subtitle}
        </div>
      )}
      {action}
    </div>
  );
}
